//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};